import { PlatformPlugin } from '@segment/analytics-react-native';
import { Platform } from 'react-native';
export class CookieAwareEnrichmentPlugin extends PlatformPlugin {
    isWeb = Platform.OS === 'web';
    async getCookieValue(name) {
        if (!this.isWeb)
            return undefined;
        try {
            if (typeof cookieStore !== 'undefined') {
                const cookie = await cookieStore.get(name);
                if (cookie) {
                    return cookie.value;
                }
                else {
                    return undefined;
                }
            }
        }
        catch (err) {
            console.debug('[Segment Analytics] error fetching cookie value from `cookieStore`.');
        }
        try {
            const regex = new RegExp(`(^| )${name}=([^;]+)`);
            const match = document.cookie.match(regex);
            if (match) {
                return match[2];
            }
        }
        catch (err) {
            console.debug('[Segment Analytics] error fetching cookie value via regex.');
        }
        return undefined;
    }
    async getCookiesWithPrefix(prefix) {
        try {
            if (typeof cookieStore !== 'undefined') {
                const cookies = (await cookieStore.getAll())
                    .filter((cookie) => {
                    return cookie?.name?.startsWith(prefix) || false;
                })
                    .reduce((acc, cookie) => {
                    acc[cookie.name] = cookie.value;
                    return acc;
                }, {});
                return cookies;
            }
        }
        catch (err) {
            console.debug('[Segment Analytics] error fetching cookies with prefix from `cookieStore`.');
        }
        try {
            const cookies = document.cookie.split(';')
                .map((c) => {
                const split = c.trim().split('=');
                return {
                    key: split[0],
                    value: decodeURIComponent(split[1]).split('|')[0],
                };
            })
                .filter((c) => c.key.startsWith(prefix))
                .reduce((acc, cookie) => {
                acc[cookie.key] = cookie.value;
                return acc;
            }, {});
            return cookies;
        }
        catch (err) {
            console.debug('[Segment Analytics] error fetching cookie value via regex.');
        }
        return {};
    }
}
//# sourceMappingURL=CookieAwareEnrichmentPlugin.js.map